import { render } from "./RequestsList.vue?vue&type=template&id=15f290c8&scoped=true"
import script from "./RequestsList.vue?vue&type=script&lang=js"
export * from "./RequestsList.vue?vue&type=script&lang=js"

import "./RequestsList.vue?vue&type=style&index=0&id=15f290c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f290c8"]])

export default __exports__